import { ReactNode } from 'react';
import { Navigate, } from 'react-router-dom';

import { useSessionContext } from '../useSessionContext';
import { PATHS_SOLVER } from 'routes/paths';
import { AccountRole } from '@piccadilly-cloud/platform-services';

// ----------------------------------------------------------------------

type FacilitatorGuardProps = {
  children: ReactNode;
};

export default function FacilitatorGuard({ children }: FacilitatorGuardProps) {
  const { account } = useSessionContext();

  const facilitatorRoles: Record<AccountRole, boolean> = {
    'ROOT': true,
    'ACCOUNT_HOLDER': true,
    'FACILITATOR': true,
    'SINGLE_GROUP_FACILITATOR': true,
    'SINGLE_COHORT_FACILITATOR': true,
    'SOLVER': false,
    'GUEST': false,
  }

  if (!facilitatorRoles[account.accountRole]) {
    return <Navigate to={PATHS_SOLVER.dashboard} />
  }

  return <>{children}</>;
}


